import React from "react";
import { InfoWrapper } from "./style";
import PropTypes from "prop-types";

const Info = (props) => {
	const { info } = props;

	return (
		<InfoWrapper>
			{info.map((infoData, index) => (
				<div key={index} className="infoBlock">
					<div className="infoHeading">{infoData.name}</div>
					<div className="infoContent">{infoData.detail}</div>
				</div>
			))}
		</InfoWrapper>
	);
};

Info.propTypes = {
	info: PropTypes.array,
};

Info.defaultProps = {
	info: [],
};

export default Info;
